// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-tree[data-v-84676742] {\n  position: relative;\n  padding-right: 24px;\n  padding-top: 46px;\n  width: 100%;\n  height: 100%;\n  font-size: 12px;\n  color: #333333;\n}\n.custom-tree .selectFilterNum[data-v-84676742] {\n    position: absolute;\n    left: 25px;\n    bottom: 68px;\n    font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
